module.exports = __webpack_public_path__ + "static/media/culture-secondary.d86e4f65.jpg";